import { Component, OnInit, ViewChild , ElementRef, Input, Inject} from '@angular/core';
import { apiService } from '../../../../../../service/api.service';
import { MatTableDataSource } from '@angular/material/table';
import { CuentasJardinModel, ResponseCuentasJardinModel, ResponseOtrasCuentasModel, ResponseCuentasModel, CuentasModel, CuentaJardinPeriodoModel, ResponseCuentasJardinPaginationModel } from '../../../../../../model/Cuentas.model'
import { MatPaginator, PageEvent} from '@angular/material/paginator';
import { MatSort} from '@angular/material/sort';
import { ModalFichaCuentaComponent } from '../../../dialogs/modal-ficha-cuenta/modal-ficha-cuenta.component';
import { MatDialog } from '@angular/material/dialog'; 
import { NgxSpinnerService } from "ngx-spinner";
import { JardinModel, ResponseJardinModel } from 'src/app/model/Jardin.model';
import Swal from 'sweetalert2';
import { AdministracionComponent } from '../../administracion.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-cuentas-jardin',
  templateUrl: './cuentas-jardin.component.html',
  styleUrls: ['./cuentas-jardin.component.css']
})
export class CuentasJardinComponent implements OnInit {

  displayedColumns=[];
  filterValues = {};
  filterSelectObj = [];
  tipoCampos = [];
  arrayComunas = [];
  dataSource: MatTableDataSource<CuentasJardinModel>;
  palabraClave: string;
  idRegion:number;
  idComuna:number;
  idPrograma:number;
  pageEvent: PageEvent;
  pageIndex:number;
  length:number;
  getSelect = false;
  apiEndpoint = environment.apiEndpoint;
  columnNames = [
    { id: 'region', value: 'region' }, 
    { id: 'comuna', value: 'comuna' }, 
    { id: 'programa', value: 'programa' }, 
    { id: 'modalidad', value: 'modalidad' }, 
    { id: 'codigo', value: 'codigo' }, 
    { id: 'nombre', value: 'nombre' }, 
    { id: 'usuario', value: 'usuario' }, 
    { id: 'pass', value: 'pass' }, 
    { id: 'bloqueo', value: 'bloqueo' }, 
    { id: 'acciones', value: 'acciones' }, 

  ];
  @ViewChild(MatPaginator, {read: true}) paginator: MatPaginator;
  @Input() infoSelectJardin: CuentasModel;

  
  constructor(
    @Inject(AdministracionComponent) private parent: AdministracionComponent,
    private api: apiService,    
    public dialog: MatDialog,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit(): void {
    this.palabraClave = "";
    this.idRegion = 0;
    this.idComuna = 0;
    this.idPrograma = 0;
    this.getServerData(); 
  }

  
  public getServerData(event?:PageEvent){
    this.callData(event != null ? event : null );
  }


  public callData(event?:PageEvent){
    let pageNum = event != null ? (event.pageIndex + 1) : 1;
    let pageSize = event != null ? event.pageSize : 10;
    this.spinner.show();
    this.api.API_POST_getCuentasJardinAdmin(pageNum,pageSize,this.palabraClave,this.idRegion,this.idComuna,this.idPrograma).subscribe((response: ResponseCuentasJardinPaginationModel) => {
      this.displayedColumns = this.columnNames.map(x => x.id);
      this.dataSource = new MatTableDataSource<CuentasJardinModel>(response.payload.list);
      this.pageIndex = (response.payload.pageNum - 1);
      //this.pageSize = response.payload.pageSize;
      this.length = response.payload.total;
      setTimeout(() => {
        this.dataSource.paginator = this.paginator;
        this.spinner.hide();
      }, 1000);
        
    },
    (err) => {
      console.log("error"+err)
    })
  }

  
  bloquear(row:CuentasJardinModel, tipo: string){
      this.spinner.show();
      this.api.API_POST_bloquearUsuario(row.id, tipo).subscribe((response: ResponseOtrasCuentasModel) => {
          this.spinner.hide();
      },
      (err) => {
        console.log(err)
        alert(err)
        this.spinner.hide();
      })
  } 

  buscar(palabraClave){
    this.palabraClave = palabraClave;
    this.callData(null);
  }
  

  verCuentaJardin(row:CuentasJardinModel){

    const dialogRef = this.dialog.open(ModalFichaCuentaComponent,{
      disableClose: true ,
      width: '50%',
      data: {idJardinPeriodo: row.id, dataSelects: this.infoSelectJardin}
    });

    dialogRef.afterClosed().subscribe((result) => {
      //this.cargando = true;
      this.getServerData();
    });
  }

  abrirPlanMejora(row:CuentasJardinModel){
    console.log(row);
    const texto = "Desea Abrir el Plan de Mejora para el Jardin " + row.nombre + " RDB " + row.codigo + " ?";
    this.spinner.hide();
    Swal.fire({
      title: texto,
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: 'Abrir',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        this.api.API_POST_AbrirPlanMejora(row.id).subscribe((response: ResponseOtrasCuentasModel) => {
          this.spinner.hide();
          Swal.fire({
            icon: 'success',
            title: 'Se ha habilitado el plan de mejora',
            confirmButtonText: 'OK'
          })
      },
      (err) => {
        console.log(err)
        alert(err)
        this.spinner.hide();
      })
      }
    })
  }

  crearCuentaJardin(){ 
    const dialogRef = this.dialog.open(ModalFichaCuentaComponent,{
      disableClose: true ,
      width: '50%',
      data: {idJardinPeriodo: 0, dataSelects: this.infoSelectJardin}
    });

    dialogRef.afterClosed().subscribe((result) => {
  
      if(result != null && result != ''){
        //this.cargando = true;
        this.getServerData();
      } 
    });
  }

  seleccionarRegion(value){
    this.idRegion = value;
    const indexRegion =this.infoSelectJardin.regiones.map(element => element.idRegion).indexOf(value);
    this.arrayComunas = this.infoSelectJardin.regiones[indexRegion].comunas;
    this.callData(null);
  }

  seleccionarComuna(value){
    this.idComuna = value;
    this.callData(null);
  }

  seleccionarPrograma(value){
    this.idPrograma = value;
    this.callData(null);
  }

  editarCuentaJardin(row:CuentasJardinModel, position){ 
  
    const dialogRef = this.dialog.open(ModalFichaCuentaComponent,{
      disableClose: true ,
      width: '50%',
      data: {idJardinPeriodo: row.id, dataSelects: this.infoSelectJardin}
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.getServerData();
    });
    
  }

  nombreRegion(id){
    const indexRegion =this.infoSelectJardin.regiones.map(element => element.idRegion).indexOf(id);
    return this.infoSelectJardin.regiones[indexRegion].nombre;
  }

  nombreComuna(idRegion,IdComuna){
    const indexRegion = this.infoSelectJardin.regiones.map(element => element.idRegion).indexOf(idRegion);
    const indexComuna = this.infoSelectJardin.regiones[indexRegion].comunas.map(element => element.idComuna).indexOf(IdComuna);
    return this.infoSelectJardin.regiones[indexRegion].comunas[indexComuna].nombre;
  }


  simular(jardin : any){
    this.spinner.show();
    this.api.API_POST_obtenerJardinPorRBD(parseInt(jardin.codigo)).subscribe((response:ResponseJardinModel) => {
      this.api.dataJardin = response.payload;
      this.parent.jardinSeleccionado  = response.payload;
      this.parent.showSimulacion = true;
      this.spinner.hide();
    },
    (err) => { 
      console.log(err)
      this.spinner.hide();
      Swal.fire({
        title: 'Error!',
        text: 'Error al Cargar Jardín',
        icon: 'error',
        confirmButtonText: 'OK'
      })
    })
    
  }
}
